export const visit = (vm, at) => {
vm(require("documents-lib/lang/view/hi.lyaml"));
at({ "hi": { "public": { "sampleString": "\u0928\u092E\u0942\u0928\u093E \u0938\u094D\u091F\u094D\u0930\u093F\u0902\u0917" } } });
};